module.exports = __webpack_public_path__ + "static/l3-f1eed9a4e086bf75d6aff525f1050ea2.jpg";